<nav
    class="navbar navbar-expand-lg navbar-light bg-light"
    [class.active]="classApplied"
    [ngClass]="{'sticky': isSticky}"
>
    <div class="container">
        <a *ngIf="isSticky" class="navbar-brand logo" routerLink="/"><img src="assets/img/opora_logo_black.png" /></a>
        <a *ngIf="!isSticky" class="navbar-brand logo" routerLink="/"><img src="assets/img/opora_logo.png" /></a>

        <button class="navbar-toggler" type="button" (click)="toggleClass()">
            <span class="burger-menu">
                <span class="top-bar"></span>
                <span class="middle-bar"></span>
                <span class="bottom-bar"></span>
            </span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
                <li class="nav-item"><span class="nav-link" (click)="onClick('welcome')">О курсе</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('education_system')">Программа курса</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('team')">Эксперты курса</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('pricing')">Тарифы</span></li>
                <li class="nav-item"><span class="nav-link" (click)="onClick('contact')">Контакты</span></li>
            </ul>
            <ul class="navbar-nav ml-auto for-responsive">
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('welcome')">О курсе</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('education_system')">Программа курса</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('team')">Эксперты курса</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('pricing')">Тарифы</span></li>
                <li class="nav-item"><span class="nav-link" (click)="toggleClass(); onClick('contact')">Контакты</span></li>
            </ul>
        </div>
    </div>
</nav>
